import { useEffect } from "react";
import { createPortal } from "react-dom";
import { PdfDocumentViewer } from "./PdfDocumentViewer.js";

export interface ActiveDocumentView {
  documentId?: string;
  documentVersionId?: string;
  attachmentId?: string;
  threadId?: string;
  title: string;
  initialPage?: number;
  highlightText?: string;
}

interface DocumentViewerPanelProps {
  document: ActiveDocumentView;
  onClose: () => void;
}

export function DocumentViewerPanel({ document: activeDocument, onClose }: DocumentViewerPanelProps) {
  useEffect(() => {
    const previous = window.document.body.style.overflow;
    window.document.body.style.overflow = "hidden";
    return () => {
      window.document.body.style.overflow = previous;
    };
  }, []);

  return createPortal(
    <div className="fixed inset-0 z-[100] flex justify-end">
      <button
        type="button"
        className="absolute inset-0 bg-[var(--overlay)] backdrop-blur-[1px] dark:bg-slate-950/65"
        aria-label="Close document preview"
        onClick={onClose}
      />
      <aside
        className="relative z-10 flex h-full w-full max-w-[960px] min-w-0 flex-col border-l border-[var(--lm-border-subtle)] bg-white shadow-[-12px_0_40px_rgba(16,24,40,0.12)] dark:border-white/10 dark:bg-[#0b1120] dark:shadow-[-12px_0_40px_rgba(0,0,0,0.55)] sm:w-[min(960px,62vw)]"
        role="dialog"
        aria-modal="true"
        aria-label={`Preview ${activeDocument.title}`}
      >
        <PdfDocumentViewer
          key={`${activeDocument.documentId ?? activeDocument.attachmentId}-${activeDocument.documentVersionId ?? "latest"}-${activeDocument.initialPage ?? 1}-${activeDocument.highlightText ?? ""}`}
          documentId={activeDocument.documentId}
          documentVersionId={activeDocument.documentVersionId}
          attachmentId={activeDocument.attachmentId}
          threadId={activeDocument.threadId}
          title={activeDocument.title}
          initialPage={activeDocument.initialPage ?? 1}
          highlightText={activeDocument.highlightText}
          onClose={onClose}
        />
      </aside>
    </div>,
    window.document.body,
  );
}
